module.exports = __webpack_public_path__ + "static/assets/901da59b402640a2615d111d474a7ede.svg";